import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FilterViewModel, MasterFilterModel } from 'src/app/core/models/regulation';
import { RegulationService } from 'src/app/core/services/regulation';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { SingleImportUpdateModel } from 'src/app/core/models/manualUpdates/single-import';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-add-single-manual-update',
  templateUrl: './add-single-manual-update.component.html',
  styleUrls: ['./add-single-manual-update.component.scss']
})
export class AddSingleManualUpdateComponent implements OnInit {
  isLoadingFilters = false;
  masterFilters!: MasterFilterModel;
  InputModel!: SingleImportUpdateModel;
  constructor(
    private regulationService: RegulationService,
  ) {
    this.InputModel = new SingleImportUpdateModel();
  }
  searchedRegulators: FilterViewModel[] = [];
  searchedCountries: FilterViewModel[] = [];
  searchedGeographies: FilterViewModel[] = [];
  searchedTopics: FilterViewModel[] = [];
  
  keywords: string[] = [];
  searchedKeywords = [];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  searchRegulatorCntrl: FormControl = new FormControl();
  searchRuleTopicFormControl: FormControl = new FormControl();
  searchCountryCntrl: FormControl = new FormControl();
  searchGeographyCntrl: FormControl = new FormControl();

  @ViewChild("UpdateForm")
  UpdateForm!: NgForm;
  @Input("regulationId") regulationId: any;
  @ViewChild('textArea', { read: ElementRef })
  textArea!: ElementRef;
  RuleTopic!: string[];
  @ViewChild('ruleTopicInput')
  ruleTopicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ruleTopicAutocomplete')
  ruleTopicAutocomplete!: MatAutocomplete;
  isRuleValid=true;

  ngOnInit(): void {
    this.getMasterFilters();
  }
  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.regulationService.getMasterFilters().subscribe((data: MasterFilterModel) => {
      this.masterFilters = data;
      this.searchedRegulators = this.masterFilters.regulators;
      this.searchedCountries = this.masterFilters.countries;
      this.searchedGeographies = this.masterFilters.geographys;
      this.searchedTopics = this.masterFilters.ruleTopics;
      this.isLoadingFilters = false;
      if (this.regulationId) {
        this.getRegulatioDetails();
      }
      this.searchRuleTopicFormControl.valueChanges.subscribe((term: any) => {
        this.searchedTopics = term ? this.filterRuleTopics(term) : this.masterFilters.ruleTopics;
      });
    },
      (error: HttpErrorResponse) => {
        // this.isLoadingFilters = false;
        // Logger.log(this.constructor.name, error.error);
      }
    );
  }
  filterRegulators(search: string): any {
    return this.searchedRegulators.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  filterCountry(search: string): any {
    return this.searchedCountries.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterGeography(search: string): any {
    return this.searchedGeographies.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  
  filterRuleTopics(search: string): any {
    // return this.searchedTopics.filter(value => value.Name.toLowerCase().indexOf(search.toLowerCase()) === 0);
    return this.searchedTopics.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  SaveUpdate(): string|null {
    let division = localStorage.getItem('selectedDivision');
    this.InputModel.jurisdiction = division?division:"";
    if(this.RuleTopic){
      this.InputModel.ruleTopic=this.RuleTopic.toString()
    }
    if (this.UpdateForm.form.valid && this.RuleTopic && this.RuleTopic.length>0) {
      //more code here
      this.regulationService.saveRegulationSingleDetail(this.InputModel).subscribe((result: any) => { })
      return "Valid";
    }
    else {
      if(!this.RuleTopic || this.RuleTopic.length==0){
        this.isRuleValid=false;
      }
      //this.searchRuleTopicFormControl.markAsTouched();
      this.UpdateForm.form.markAllAsTouched();
      return "Invalid";
    }
  }
  selectedRegulatorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.InputModel.regulator) {
      let filterRegulator = this.searchedRegulators.filter((obj) => obj.value == this.InputModel.regulator);
      if (filterRegulator && filterRegulator.length > 0) {
        let arr = filterRegulator[0].value.split(':');
        if (arr.length > 1) {
          this.InputModel.regulator = arr[1].trim();
        }
      }
      this.searchedRegulators = this.masterFilters.regulators;
    }
  }
  getRegulatioDetails() {
    this.regulationService.getRegulationSingleDetail(this.regulationId).subscribe((result: SingleImportUpdateModel) => {
      this.InputModel = result;
    })
  }
  applyFilterOnRegulator(term: string) {
    this.searchedRegulators = term ? this.filterRegulators(term) : this.masterFilters.regulators;
  }
  applyFilterOnGeography(term: string) {
    this.searchedGeographies = term ? this.filterGeography(term) : this.masterFilters.geographys;
  }
  applyFilterOnCountry(term: string) {
    this.searchedCountries = term ? this.filterCountry(term) : this.masterFilters.countries;
  }
  applyFilterOnTopic(term: string) {
    this.searchedTopics = term ? this.filterRuleTopics(term) : this.masterFilters.ruleTopics;
  }
  keyPressAlphaNumeric(event:any) {
    var inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets, space, underscore
    if (/[a-zA-Z0-9-_ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  keyPressAlphaNumericRule(event:any) {
    var inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets, space, underscore
    if (/[a-zA-Z0-9-_ ]/.test(inp)) {
      this.isRuleValid=true;
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  public autoGrow() {
    const textArea = this.textArea.nativeElement;
    textArea.style.overflow = 'hidden';
    textArea.style.height = '0px';
    textArea.style.height = textArea.scrollHeight + 'px';
  }
  
  removeTopic(type: string): void {
    const index = this.RuleTopic.indexOf(type);
    if (index >= 0) {
      this.RuleTopic.splice(index, 1);
    }
  }

  addTopic(event: MatChipInputEvent): void {
    if (!this.ruleTopicAutocomplete.isOpen) {
      const value = event.value;
      if (!this.RuleTopic) {
        this.RuleTopic = [];
        this.RuleTopic.push(value.trim());
        this.isRuleValid=true;
      }
      else if ((value || '').trim()) {
        this.RuleTopic.push(value.trim());
        this.isRuleValid=true;
      }
      event.chipInput!.clear();
      this.searchRuleTopicFormControl.setValue(null);
    }
  }
  selectedTopicEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.RuleTopic) {
      this.RuleTopic.push(event.option.viewValue);
      this.isRuleValid=true;
    } else {
      this.RuleTopic = [];
      this.RuleTopic.push(event.option.viewValue);
      this.isRuleValid=true;
    }
    this.ruleTopicInput.nativeElement.value = '';
    this.searchRuleTopicFormControl.setValue(null);
    this.searchRuleTopicFormControl.disable();
    this.searchRuleTopicFormControl.enable();

  }
  selectedGeography(){
    this.searchedGeographies = this.masterFilters.geographys;
  }
  selectedCountry(){
    this.searchedCountries = this.masterFilters.countries;
  }
  selectedRegulator(){
    this.searchedRegulators = this.masterFilters.regulators;
  }
 }
